// React Libraries
import React, { useMemo } from 'react'
// import PropTypes from 'prop-types'
// const moment = require('moment');
import { withTranslation } from 'react-i18next'

// Styles
import styled from '@emotion/styled'

const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  ${(props) =>
    props.left &&
    `
    align-items: flex-start;
    text-align: left;
  `} ${(props) =>
    props.right &&
    `
      text-align: right;
      align-items: flex-end;
  `};
`

// Component
function Header({ t, invoice, company, invoiceSettings, page }) {
  const { language, accentColor, customAccentColor } = invoiceSettings
  const { logoUrl } = invoiceSettings

  const Wrapper = styled.div`
    position: absolute;
    z-index: 1;
    height: calc(6cm - 0.55in);
    left: 0;
    right: 0;
    padding-left: inherit;
    padding-right: inherit;
    display: flex;
    padding-top: inherit;
    top: 0;
    justify-content: space-between;
    flex-direction: ${invoiceSettings.logoPosition === 'left'
      ? 'row'
      : 'row-reverse'};
    @media print {
      .logo {
        position: fixed;
        padding-left: inherit;
        padding-right: inherit;
        left: ${invoiceSettings.logoPosition === 'left' ? '0px' : 'initial'};
        right: ${invoiceSettings.logoPosition === 'left' ? 'initial' : '0px'};
      }
      .company-information.top {
        text-align: ${invoiceSettings.logoPosition === 'left'
          ? 'right'
          : 'left'};
        position: absolute;
        left: ${invoiceSettings.logoPosition === 'left' ? 'initial' : '0px'};
        right: ${invoiceSettings.logoPosition === 'left' ? '0px' : 'initial'};
        padding-right: inherit;
        padding-left: inherit;
      }
    }
  `
  const logo = useMemo(() => {
    return (
      <div className='logo'>
        {logoUrl ? (
          <img src={logoUrl} alt='Logo' />
        ) : (
          <h1 className='text-logo'>{invoiceSettings.textLogo}</h1>
        )}
      </div>
    )
  }, [logoUrl, invoiceSettings.textLogo])
  return (
    <Wrapper>
      {logo}
      {invoiceSettings.companyInformationPosition === 'top' && (
        <div className='company-information top'>
          <p className='label company-name'>{company.name}</p>
          {company.address && (
            <p>
              {company.address.line1} <br />
              {company.address.line2 && company.address.line2 + '\n'}
              {company.address.postalCode} {company.address.city}
              <br />
              {company.phone && company.phone + '\n'}
            </p>
          )}
          {(company.website || company.email) && (
            <p>
              {company.email && company.email + '\n'}
              {company.website && company.website + '\n'}
            </p>
          )}
          <p>
            {company.companyRegistrationNumber && (
              <React.Fragment>
                {t('kvkNumber')}:{'   '}
                {company.companyRegistrationNumber}
                <br />
              </React.Fragment>
            )}
            {company.vatIdentificationNumber && (
              <React.Fragment>
                {t('vatNumber')}:{'   '}
                {company.vatIdentificationNumber}
                <br />
              </React.Fragment>
            )}
            {company.bankAccountNumber && (
              <React.Fragment>
                {t('bankAccount')}:{'   '}
                {company.bankAccountNumber}
                <br />
              </React.Fragment>
            )}
          </p>
        </div>
      )}
    </Wrapper>
  )
}

// Header.propTypes = {
//   configs: PropTypes.object.isRequired,
//   invoice: PropTypes.object.isRequired,
//   company: PropTypes.object.isRequired,
//   t: PropTypes.func.isRequired
// }

export default withTranslation()(Header)
